export default __webpack_public_path__ + "static/media/user-list.651ee4e3.svg";